import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Icon } from '..';
import AsyncButton from '../Forms/AsyncButton';

function ConfirmModal({
  isOpen,
  title,
  onConfirm,
  onCancel,
  confirmButtonLabel,
  children,
  headerStyle = 'primary',
  confirnButtonColor = 'primary',
}) {
  return (
    <Modal isOpen={isOpen}>
      <ModalHeader>
        <div className={headerStyle}>
          <Icon
            fixedWidth
            icon={['fas', 'exclamation-triangle']}
            className="mr-2"
          />
          {title}
        </div>
      </ModalHeader>
      <ModalBody>
        {children}
        <hr />
      </ModalBody>
      <ModalFooter>
        {onCancel && <Button onClick={onCancel}>Cancel</Button>}
        <AsyncButton
          color={confirnButtonColor}
          onClick={onConfirm}
          data-test="confirm-btn"
        >
          {confirmButtonLabel ?? 'Submit'}
        </AsyncButton>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmModal;
